"use client"

import type { TeamMember } from "./api"
import { useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"
import Image from "next/image"

const IMAGE_PLACEHOLDER = "blur" as const;

export default function TeamMemberCard({ member }: { member: TeamMember }) {
    const [isExpanded, setIsExpanded] = useState(false)
    // Destructure properties from the DonistaImage object
    const { src, alt } = member.image

    return (
        <div className="flex flex-col items-center">
            {/* Team member image */}
            <div className="w-full aspect-square relative mb-4 p-2 overflow-hidden">
                <Image
                    src={src}
                    alt={alt || member.name}
                    fill
                    className="object-cover"
                    priority
                    placeholder={IMAGE_PLACEHOLDER}
                    blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcUA8AAcUBIa+1gC8AAAAASUVORK5CYII="
                />
            </div>

            {/* Name with expand/collapse button */}
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="flex items-center justify-center gap-2 w-full py-2 text-xl font-medium border-t border-b"
            >
                {member.name}<br/>{member.role}
                {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
            </button>

            {/* Expandable content */}
            {isExpanded && (
                <div className="py-4 px-2 w-full">
                    <p className="text-muted-foreground">{member.motivation}</p>
                    {member.funFact && <p className="mt-4 text-muted-foreground italic">{member.funFact}</p>}
                </div>
            )}
        </div>
    )
}
